/* DFJ Consult (Rev) — FIXED SERIALIZATION */
(function () {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const form = qs("#dfjConsultRevForm");
  if (!form) return;

  // Stop Globo from hijacking this form
  form.setAttribute("data-globo-form", "ignore");

  const DRAFT_KEY = "dfjConsultDraftRev";

  const SUBMIT_ENDPOINT =
    "https://script.google.com/macros/s/AKfycby3TK0eu2jN0KAlqyAIjqEKz_XGko1N0Qh05plpEXu9aq7LcL2UYhKREef5oOxrE0bPkg/exec";

  const branches = qsa(".dfj-branch");
  const productType = qs("#productType");
  const customerType = qs("#customerType");
  const primaryPhone = qs("#primaryPhone");
  const primaryEmail = qs("#primaryEmail");
  const statusBox = qs("#dfjFormStatus");

  // Ensure hidden iframe exists for CORS-safe posts (prevents "OK" page takeover)
  function ensureHiddenFrame() {
    let iframe = qs('iframe[name="dfjHiddenFrame"]');
    if (iframe) return iframe;

    iframe = document.createElement("iframe");
    iframe.name = "dfjHiddenFrame";
    iframe.id = "dfjHiddenFrame";
    iframe.style.display = "none";
    iframe.setAttribute("aria-hidden", "true");
    document.body.appendChild(iframe);
    return iframe;
  }

  /* ------------------------------
     BRANCH TOGGLE
  ------------------------------ */
  function toggleBranch() {
    const val = productType ? productType.value : "";
    branches.forEach(b => (b.hidden = b.dataset.branch !== val));
  }

  if (productType) {
    productType.addEventListener("change", () => {
      toggleBranch();
      saveDraft();
    });
  }

  function syncPrimaryContactRequired() {
    const rawType = customerType ? String(customerType.value || "").toLowerCase() : "";
    const isExisting = rawType.startsWith("exist") || rawType === "exisiting";

    [primaryPhone, primaryEmail].forEach(el => {
      if (!el) return;
      el.required = !isExisting;
      if (isExisting) {
        el.removeAttribute("aria-required");
      } else {
        el.setAttribute("aria-required", "true");
      }
    });

    const phoneReq = qs('label[for="primaryPhone"] .dfj-req', form);
    const emailReq = qs('label[for="primaryEmail"] .dfj-req', form);
    if (phoneReq) phoneReq.hidden = isExisting;
    if (emailReq) emailReq.hidden = isExisting;
  }

  if (customerType) {
    customerType.addEventListener("change", () => {
      syncPrimaryContactRequired();
      saveDraft();
    });
  }

  /* ------------------------------
     PHONE FORMAT: XXX-XXX-XXXX
  ------------------------------ */
  function formatPhone(value) {
    const digits = (value || "").replace(/\D/g, "").slice(0, 10);
    const a = digits.slice(0, 3);
    const b = digits.slice(3, 6);
    const c = digits.slice(6, 10);
    if (digits.length <= 3) return a;
    if (digits.length <= 6) return `${a}-${b}`;
    return `${a}-${b}-${c}`;
  }

  ["#primaryPhone", "#partnerPhone"].forEach(sel => {
    const el = qs(sel);
    if (!el) return;
    el.addEventListener("input", () => {
      const caretAtEnd = el.selectionStart === el.value.length;
      el.value = formatPhone(el.value);
      if (caretAtEnd) el.setSelectionRange(el.value.length, el.value.length);
      saveDraft();
    });
  });

  /* ------------------------------
     DROPDOWN GENERATORS
  ------------------------------ */
  function fillSelectRange(sel, start, end, step, decimals = 2) {
    if (!sel || sel.dataset.filled) return;
    for (let v = start; v <= end + 0.0001; v += step) {
      const opt = document.createElement("option");
      opt.value = v.toFixed(decimals);
      opt.textContent = v.toFixed(decimals);
      sel.appendChild(opt);
    }
    sel.dataset.filled = "1";
  }

  function initSelects() {
    qsa("#er_ringSize, #wb_primary_ringSize, #wb_partner_ringSize")
      .forEach(sel => fillSelectRange(sel, 2, 15, 0.25));

    qsa("#wb_primary_mmWidth_1, #wb_primary_mmWidth_2")
      .forEach(sel => fillSelectRange(sel, 2, 10, 0.5, 2));
  }

  /* ------------------------------
     CONDITIONAL TOGGLES
  ------------------------------ */
  function initToggles() {
    qsa("[data-dfj-toggle]").forEach(cb => {
      const target = qs(cb.dataset.dfjToggle);
      if (!target) return;

      const sync = () => (target.hidden = !cb.checked);

      cb.addEventListener("change", () => {
        sync();
        saveDraft();
      });

      sync();
    });
  }

  /* ------------------------------
     TICKS RENDERER (POSITION-AWARE)
  ------------------------------ */
  function renderTicks() {
    qsa(".dfj-ticks").forEach(ticksEl => {
      const raw = ticksEl.dataset.dfjTicks;
      if (!raw) return;

      const items = raw.split(",").map(s => s.trim()).filter(Boolean);
      const fmt = ticksEl.dataset.dfjFormat || "text";

      // Find the parent range wrapper
      const rangeWrap = ticksEl.closest(".dfj-range");
      const firstSlider = rangeWrap ? rangeWrap.querySelector(".dfj-range__input") : null;
      
      // Check if this is a discrete slider (has data-dfj-discrete attribute)
      const isDiscrete = rangeWrap && rangeWrap.dataset.dfjDiscrete;
      
      let min = 0;
      let max = 100;
      
      if (firstSlider) {
        min = parseFloat(firstSlider.min) || 0;
        max = parseFloat(firstSlider.max) || 100;
      }

      ticksEl.innerHTML = "";

      const labelText = (txt) => {
        if (fmt === "money") {
          const n = Number(txt);
          return isFinite(n) ? `$${n.toLocaleString("en-US")}` : txt;
        }
        if (fmt === "number") {
          const n = Number(txt);
          return isFinite(n) ? String(n) : txt;
        }
        return txt;
      };

      items.forEach((txt, idx) => {
        const s = document.createElement("span");
        s.textContent = labelText(txt);
        
        let percent;
        
        if (isDiscrete) {
          // For discrete sliders (Color, Clarity): evenly space the labels
          // because the slider uses indices 0,1,2,3... regardless of the text values
          percent = (idx / (items.length - 1)) * 100;
        } else {
          // For numeric sliders (Budget, Carat): calculate based on actual values
          const value = parseFloat(txt) || 0;
          percent = ((value - min) / (max - min)) * 100;
        }
        
        // Position the span at the calculated percentage
        // (first and last will be overridden by CSS)
        if (idx !== 0 && idx !== items.length - 1) {
          s.style.left = `${percent}%`;
        }
        
        ticksEl.appendChild(s);
      });
    });
  }

  /* ------------------------------
     DUAL RANGE SLIDERS
  ------------------------------ */
  function initDualRanges() {
    qsa(".dfj-range").forEach(wrap => {
      const inputs = qsa('input[type="range"]', wrap);
      if (inputs.length !== 2) return;

      const [minEl, maxEl] = inputs;
      const outSel = minEl.dataset.dfjDisplay || maxEl.dataset.dfjDisplay;
      const out = outSel ? qs(outSel) : null;

      const discrete = wrap.dataset.dfjDiscrete
        ? wrap.dataset.dfjDiscrete.split(",").map(s => s.trim())
        : null;

      const isBudget =
        (minEl.name || "").toLowerCase().includes("budget") ||
        (wrap.dataset.range || "").toLowerCase() === "budget";

      function valueToLabel(v) {
        if (discrete) {
          const idx = parseInt(v, 10);
          return discrete[idx] ?? "";
        }

        if (isBudget) {
          const n = Math.round(Number(v));
          return `$${n.toLocaleString("en-US")}`;
        }

        // For carat slider (numeric values)
        const n = Number(v);
        return isFinite(n) ? n.toFixed(2) : String(v);
      }

      function clamp() {
        let minV = Number(minEl.value);
        let maxV = Number(maxEl.value);

        if (minV > maxV) {
          const active = document.activeElement;
          if (active === minEl) {
            minEl.value = String(maxV);
          } else if (active === maxEl) {
            maxEl.value = String(minV);
          } else {
            minEl.value = String(maxV);
          }
        }
      }

      function update() {
        clamp();

        const minV = minEl.value;
        const maxV = maxEl.value;

        const minNum = Number(minEl.min);
        const maxNum = Number(minEl.max);
        const a = (Number(minV) - minNum) / (maxNum - minNum);
        const b = (Number(maxV) - minNum) / (maxNum - minNum);
        wrap.style.setProperty("--dfj-a", String(Math.max(0, Math.min(1, a))));
        wrap.style.setProperty("--dfj-b", String(Math.max(0, Math.min(1, b))));

        if (out) {
          const left = valueToLabel(minV);
          const right = valueToLabel(maxV);
          out.textContent = isBudget ? `${left}-${right}` : `${left} – ${right}`;
        }
      }

      minEl.addEventListener("input", () => { update(); saveDraft(); });
      maxEl.addEventListener("input", () => { update(); saveDraft(); });

      update();
    });
  }

  /* ------------------------------
     AUTOSAVE
  ------------------------------ */
  function saveDraft() {
    const data = {};
    const fd = new FormData(form);

    for (let [k, v] of fd.entries()) {
      if (k.endsWith("[]")) {
        const key = k.replace("[]", "");
        data[key] = data[key] || [];
        data[key].push(v);
      } else {
        data[k] = v;
      }
    }

    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function restoreDraft() {
    let raw = null;
    try {
      raw = localStorage.getItem(DRAFT_KEY);
    } catch (e) {}

    if (!raw) return;

    let data = null;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return;
    }

    Object.keys(data).forEach(k => {
      const val = data[k];
      const els = qsa(`[name="${k}"], [name="${k}[]"]`, form);

      els.forEach(el => {
        if (el.type === "checkbox") {
          if (Array.isArray(val)) el.checked = val.includes(el.value);
          else el.checked = false;
        } else {
          el.value = val;
        }
      });
    });

    ["#primaryPhone", "#partnerPhone"].forEach(sel => {
      const el = qs(sel);
      if (el) el.value = formatPhone(el.value);
    });

    toggleBranch();
    syncPrimaryContactRequired();
  }

  function clearDraft() {
    try {
      localStorage.removeItem(DRAFT_KEY);
    } catch (e) {}
  }

  qsa("input, select, textarea", form).forEach(el => {
    el.addEventListener("change", saveDraft);
    el.addEventListener("input", saveDraft);
  });

  /* ------------------------------
     SERIALIZATION — FIXED TO MATCH CSV HEADERS
  ------------------------------ */
  function serialize() {
    const data = {};
    const fd = new FormData(form);

    // First pass: collect all raw values
    for (let [k, v] of fd.entries()) {
      if (k.endsWith("[]")) {
        const key = k.replace("[]", "");
        data[key] = data[key] || [];
        data[key].push(v);
      } else {
        data[k] = v;
      }
    }

    // Second pass: join arrays with semicolon
    Object.keys(data).forEach(k => {
      if (Array.isArray(data[k])) {
        data[k] = data[k].join("; ");
      }
    });

    // Helper to get discrete value from slider
    function getDiscreteValue(sliderEl) {
      if (!sliderEl) return "";
      const wrap = sliderEl.closest(".dfj-range");
      if (!wrap) return sliderEl.value;
      
      const discrete = wrap.dataset.dfjDiscrete;
      if (!discrete) return sliderEl.value;
      
      const items = discrete.split(",").map(s => s.trim());
      const idx = parseInt(sliderEl.value, 10);
      return items[idx] || "";
    }

    // Create the final payload with CSV-matching header names
    const payload = {};

    // Global fields (always present)
    payload.productType = data.productType || "";
    payload.customerType = data.customerType || "";
    payload.primaryName = data.primaryName || "";
    payload.primaryPhone = data.primaryPhone || "";
    payload.primaryEmail = data.primaryEmail || "";
    payload.referredBy = data.referredBy || "";
    payload.partnerName = data.partnerName || "";
    payload.partnerPhone = data.partnerPhone || "";
    payload.partnerEmail = data.partnerEmail || "";

    // Engagement Ring fields (with CSV header annotations)
    payload.er_ringSize = data.er_ringSize || "";
    payload.er_proposalDate = data.er_proposalDate || "";
    
    // Budget: combine min/max into single formatted string
    const budgetMin = data.er_budget_min ? `$${Number(data.er_budget_min).toLocaleString("en-US")}` : "";
    const budgetMax = data.er_budget_max ? `$${Number(data.er_budget_max).toLocaleString("en-US")}` : "";
    payload.er_budget = (budgetMin && budgetMax) ? `${budgetMin}-${budgetMax}` : "";

    // Arrays with "(array joined)" annotation
    payload["er_stoneType (array joined)"] = data.er_stoneType || "";
    payload.er_stoneTypeOther = data.er_stoneTypeOther || "";
    
    // Carat: combine min/max (now using 0.50 increments)
    const caratMin = data.er_carat_min ? Number(data.er_carat_min).toFixed(2) : "";
    const caratMax = data.er_carat_max ? Number(data.er_carat_max).toFixed(2) : "";
    payload.er_carat = (caratMin && caratMax) ? `${caratMin}–${caratMax}` : "";

    payload["er_shape (array joined)"] = data.er_shape || "";
    
    // Color: combine discrete min/max with "(D–K)" annotation
    const colorMinEl = qs("#er_color_min");
    const colorMaxEl = qs("#er_color_max");
    const colorMin = getDiscreteValue(colorMinEl);
    const colorMax = getDiscreteValue(colorMaxEl);
    payload["er_color (D–K)"] = (colorMin && colorMax) ? `${colorMin}–${colorMax}` : "";
    
    // Clarity: combine discrete min/max with "(FL/IF…SI2)" annotation
    const clarityMinEl = qs("#er_clarity_min");
    const clarityMaxEl = qs("#er_clarity_max");
    const clarityMin = getDiscreteValue(clarityMinEl);
    const clarityMax = getDiscreteValue(clarityMaxEl);
    payload["er_clarity (FL/IF…SI2)"] = (clarityMin && clarityMax) ? `${clarityMin}–${clarityMax}` : "";
    
    payload["er_designStyle (array joined)"] = data.er_designStyle || "";
    payload["er_metal (array joined)"] = data.er_metal || "";
    payload.er_skus = data.er_skus || "";
    payload.er_designNotes = data.er_designNotes || "";

    // Wedding Band fields
    payload.wb_weddingDate = data.wb_weddingDate || "";
    payload.wb_primary_ringSize = data.wb_primary_ringSize || "";
    payload.wb_primary_style_1 = data.wb_primary_style_1 || "";
    payload["wb_primary_metal_1 (array joined)"] = data.wb_primary_metal_1 || "";
    payload.wb_primary_mmWidth_1 = data.wb_primary_mmWidth_1 || "";
    payload.wb_primary_finish_1 = data.wb_primary_finish_1 || "";
    payload.wb_primary_price_1 = data.wb_primary_price_1 || "";
    
    payload.wb_primary_style_2 = data.wb_primary_style_2 || "";
    payload["wb_primary_metal_2 (array joined)"] = data.wb_primary_metal_2 || "";
    payload.wb_primary_mmWidth_2 = data.wb_primary_mmWidth_2 || "";
    payload.wb_primary_finish_2 = data.wb_primary_finish_2 || "";
    payload.wb_primary_price_2 = data.wb_primary_price_2 || "";
    
    payload.wb_partner_ringSize = data.wb_partner_ringSize || "";
    payload.wb_partner_style_1 = data.wb_partner_style_1 || "";
    payload["wb_partner_metal_1 (array joined)"] = data.wb_partner_metal_1 || "";
    payload["wb_partner_diamondShape_1 (array joined)"] = data.wb_partner_diamondShape_1 || "";
    payload.wb_partner_distance_1 = data.wb_partner_distance_1 || "";
    payload.wb_partner_price_1 = data.wb_partner_price_1 || "";
    
    payload['wb_partner_style_2 (second "Partner Style 1" entry stored safely)'] = data.wb_partner_style_2 || "";
    payload["wb_partner_metal_2 (array joined)"] = data.wb_partner_metal_2 || "";
    payload["wb_partner_diamondShape_2 (array joined)"] = data.wb_partner_diamondShape_2 || "";
    payload.wb_partner_distance_2 = data.wb_partner_distance_2 || "";
    payload.wb_partner_price_2 = data.wb_partner_price_2 || "";

    return payload;
  }

  /* ------------------------------
     SUBMIT
  ------------------------------ */
  form.addEventListener("submit", e => {
    e.preventDefault();
    if (statusBox) statusBox.textContent = "Submitting…";

    const payload = serialize();
    const iframe = ensureHiddenFrame();

    const onLoad = () => {
      iframe.removeEventListener("load", onLoad);

      if (statusBox) statusBox.textContent = "Saved successfully ✔ Ready for next consult.";

      form.reset();
      clearDraft();
      toggleBranch();
      syncPrimaryContactRequired();
      initDualRanges();
    };

    iframe.addEventListener("load", onLoad);

    const f = document.createElement("form");
    f.method = "POST";
    f.action = SUBMIT_ENDPOINT;
    f.target = "dfjHiddenFrame";

    Object.keys(payload).forEach(k => {
      const i = document.createElement("input");
      i.type = "hidden";
      i.name = k;
      i.value = payload[k];
      f.appendChild(i);
    });

    document.body.appendChild(f);
    f.submit();

    setTimeout(() => {
      try { f.remove(); } catch (e) {}
    }, 500);
  });

  /* ------------------------------
     CLEAR BUTTON
  ------------------------------ */
  qsa('[data-dfj-action="clear"]', form).forEach(btn => {
    btn.addEventListener("click", () => {
      form.reset();
      clearDraft();
      toggleBranch();
      syncPrimaryContactRequired();
      if (statusBox) statusBox.textContent = "";
      initDualRanges();
    });
  });

  /* ------------------------------
     INIT
  ------------------------------ */
  initSelects();
  initToggles();
  renderTicks();
  restoreDraft();
  toggleBranch();
  syncPrimaryContactRequired();
  initDualRanges();
})();
